<template>
    <div class='headerSerc'>
        <tab @getTab="getTab"></tab>
        <div id='content' v-if="status === 'content'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.logoConfig.header}}</span>
                <uploadImage :imageUrl="setTingObj.logoConfig.url" @deleteUrl="deleteLogoUrl" @updateUrl="updateLogoUrl"/>
            </div>
        </div>
        <div id='style' v-if="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgColor.title}}</span>
                <bgColor :defaultColor="setTingObj.bgColor.default" :color="setTingObj.bgColor.color" @updateBgColorA="updateBgColorA" @updateBgColorB="updateBgColorB"></bgColor>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.boxStyle.title}}</span>
                <borderRadiusPicker :boxStyleType="setTingObj.boxStyle.type" @updateBoxStyleType='updateBoxStyle'/>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.txtStyle.title}}</span>
                <txtStylePicker :txtStyleType="setTingObj.txtStyle.type" @updateTxtStyleType="updateTxtStyle"/>
            </div>
        </div>
    </div>
</template>

<script>
import tab from '@/components/decoration/common/tab.vue'
import uploadImage from '@/components/decoration/common/uploadImage.vue'
import borderRadiusPicker from '@/components/decoration/common/borderRadiusPicker.vue'
import txtStylePicker from '@/components/decoration/common/txtStylePicker.vue'
import bgColor from '@/components/decoration/common/bgColor.vue';
export default {
    components:{
        tab,
        uploadImage,
        borderRadiusPicker,
        txtStylePicker,
        bgColor,
    },
    props: {
        setTingObj: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            status: 'content'
        };
    },
    methods: {
        getTab(e){
            this.status = e
        },
        updateLogoUrl(url){
            this.setTingObj.logoConfig.url = url
        },
        deleteLogoUrl(){
            this.setTingObj.logoConfig.url = ''
        },
        updateBgColorA(e){
            this.setTingObj.bgColor.color[0].item = e
        },
        updateBgColorB(e){
            this.setTingObj.bgColor.color[1].item = e
        },
        updateBoxStyle(e){
            this.setTingObj.boxStyle.type = e
        },
        updateTxtStyle(e){
            this.setTingObj.txtStyle.type = e
        }
    }
};
</script>

<style lang='scss' scoped>

</style>